import axios from "axios";
import { baseUrl } from "../baseUrl";
import { SuccessToaster } from "../Toster";

export const ContactusApi = (formdata) => {
  let data = JSON.stringify(formdata);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}contact/us`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  axios
    .request(config)
    .then((response) => {
      SuccessToaster(response.data.message);
    })
    .catch((error) => {});
};
